import React, { useEffect, useRef, useState } from 'react';
import { ModalBox } from '@fourthwall/components';
export const IframeModal = ({ title, src, hmac, shopId, close, onRefresh }) => {
    const [iframeHeight, setIframeHeight] = useState(400);
    const iframeRef = useRef(null);
    useEffect(() => {
        const handleMessage = (event) => {
            // Verify the origin for security
            if (event.source !== iframeRef.current?.contentWindow) {
                return;
            }
            const allowedOrigin = new URL(src).origin;
            if (event.origin !== allowedOrigin) {
                console.error(`Received message from unauthorized origin: ${event.origin}`);
                return;
            }
            try {
                const { type, data } = event.data;
                switch (type) {
                    case 'CLIPBOARD':
                        navigator.clipboard.writeText(data.text);
                        break;
                    case 'SET_HEIGHT':
                        // Handle resize
                        setIframeHeight(data.height);
                        break;
                    case 'MODAL_CLOSE':
                        close();
                        // Pass refresh information back to parent
                        if (data.refresh && onRefresh) {
                            onRefresh(data.refresh);
                        }
                        break;
                    default:
                        console.error(`Received unknown message type: ${type}`, data);
                }
            }
            catch (error) {
                console.error('Error processing postMessage:', error);
            }
        };
        // Add event listener
        window.addEventListener('message', handleMessage);
        // Cleanup function
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [close, onRefresh]);
    return (React.createElement(ModalBox, { title: React.createElement("div", { style: { padding: 16 } }, title), size: "large", onClose: close, withoutPadding: true },
        React.createElement("iframe", { src: `${src}?hmac=${encodeURIComponent(hmac.signature)}&timestamp=${encodeURIComponent(hmac.timestamp)}&shop_id=${encodeURIComponent(shopId)}`, ref: iframeRef, width: "100%", height: iframeHeight, style: { border: 'none' } })));
};
